<template>
  <div class="suspension">
    <div class="nav-box">
      <div class="category">
        <infinite :nextContent="content"
                  :inputCons="inputCons"></infinite>
      </div>
    </div>
  </div>
</template>
<script>
import infinite from "./infinite.vue"
export default {
  name: "headerSuspensions",
  components: {
    infinite
  },
  props: {
    content: Array,
    inputCons: String
  },
  data () {
    return {
      // ind:-1,
      nextContent: [],
      // flowOrBlockId:'',
      // keepInd:0
    }
  },
  mounted () {
    // this.showNexts(this.content.length ? this.content[0] : '',0);
  },
  // watch:{
  //   'content':function(val){
  //     if(val){
  //       this.showNexts(this.content[0],0);
  //     }else{
  //       this.nextContent = [];
  //     }
  //   }
  // },
  //跨级触发方法
  // provide() {
  //   return {
  //     getId: this.getId,
  //   }
  // },
  methods: {
    //保存点击位数
    // keepNums(ind){
    //   this.keepInd = ind;
    // },
    //点击dom的参数
    // getId(item){
    //   this.flowOrBlockId = item.id;
    // },
    //鼠标点击展示下一级
    // showNexts (item,ind) {
    //   this.getId(item);
    //   this.ind = ind;
    //   this.$http
    //     .get(
    //       "/zciid-deliverable/showPlatformStyle/flow/api/get/getFlowFloorDataSpit.json",{
    //         appId: this.getQuery('appId'),
    //         flowId: item.id ? item.id : '',
    //         diyPageFlowId: '',
    //         domainNameType: document.location.pathname.split('/')[1],
    //         isBlock: '',
    //         userId: this.$store.state.userInfo.userId
    //       }
    //     )
    //     .then(res => {
    //       if(res.state == 1 && res.data && res.data.length){
    //         this.nextContent = res.data[0].dataArr;
    //       }
    //     })
    // },
  }
}
</script>
<style lang="scss" scoped>
.suspension {
  padding: 0 10px;
}
/* 左侧内容 */
.left-box {
  width: 182px;
  height: 337px;
  background: #fff;
  border: 1px solid #ddd;
  position: relative;
  z-index: 11;
  padding: 11px 0;
  position: relative;
}
.left-box .first {
  line-height: 28px;
  padding-left: 10px;
}
.left-box .first:hover {
  background-color: #daeeff;
}
.left-box .first .second a {
  font-size: 12px;
}
.left-box .first:last-child {
  border-bottom: 0 none;
}
/* .left-box .first:hover{ background: #daeeff;} */
.left-box .first:hover .name a,
.left-box .first:hover .change a {
  color: #333;
}
.left-box .first .name {
  background: url("../assets/image/images/index_arrow_bottom.png") no-repeat
    right;
  margin-right: 10px;
}
.left-box .first .name a,
.left-box .first .change a {
  padding: 0 5px;
  display: block;
  width: 140px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 14px;
  line-height: 30px;
}
.left-box .first .name i {
  color: #999;
}
.left-box .first:hover .name i {
  color: #fff;
}
.left-box .first .change {
  background: url("../assets/image/images/index_arrow_right.png") no-repeat
    right;
  margin-right: 10px;
}
.curr {
  background-color: #daeeff;
}
.left-box .nav-box {
  width: 888px;
  height: 340px;
  background: #fff;
  position: absolute;
  top: -1px;
  left: 182px;
  display: block; /* border: 1px solid #dddddd;*/
  z-index: 999;
  padding: 0 10px 20px 0;
  overflow-y: auto;
  // box-shadow: 0 0 3px rgba(0, 0, 0, 0.3);
  border: 1px solid #ddd;
}
/* .left-box .first:hover .nav-box{ display: block;  } */
.left-box .nav-box .category {
  line-height: 30px;
  margin: 10px 0 0 16px;
}
</style>



// WEBPACK FOOTER //
// src/components/headerSuspensions.vue